export default __webpack_public_path__ + "static/media/lenovo-yoga-logo.1680134b.svg";